function escapeCSVField(field: string): string {
  if (field.includes(",") || field.includes('"') || field.includes("\n")) {
    return `"${field.replace(/"/g, '""')}"`;
  }
  return field;
}

function downloadCSV(csvContent: string, filename: string): void {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}

export function exportToCSV(data: any[], headers: string[], filenamePrefix: string): void {
  const rows = data.map((row) =>
    headers.map((header) => {
      const field = row[header];
      if (typeof field === "string") {
        return escapeCSVField(field);
      }
      return field !== undefined && field !== null ? field.toString() : "";
    })
  );

  const csvContent = [headers, ...rows].map((row) => row.join(",")).join("\n");

  const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, "-");
  const filename = `${filenamePrefix}-${timestamp}.csv`;

  downloadCSV(csvContent, filename);
}
